var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFocusedMicrophoneOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 6,
    fill: "#0073FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8779,
    y: 26,
    width: 3,
    height: 39.425,
    transform: "rotate(45 52.8779 26)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5323 44.3454L45.6323 37.2454V27.6343C45.6323 24.5166 43.1156 22 39.998 22C36.8804 22 34.3638 24.5166 34.3638 27.6343V38.9028C34.3638 41.5131 36.1281 43.7022 38.5323 44.3454ZM35.6527 47.225C33.1082 45.8897 31.2488 43.4207 30.739 40.4991C30.5888 39.5789 29.8188 38.9028 28.8985 38.9028C27.7529 38.9028 26.8514 39.9169 27.0204 41.0438C27.6329 44.7934 29.8341 48.0024 32.91 49.9677L35.6527 47.225ZM35.7777 51.3426C36.5302 51.5965 37.3133 51.7842 38.1199 51.8991V55.8055C38.1199 56.8384 38.9651 57.6836 39.998 57.6836C41.0309 57.6836 41.8761 56.8384 41.8761 55.8055V51.8991C47.5479 51.0915 52.0553 46.678 52.9756 41.0438C53.1634 39.9169 52.2431 38.9028 51.0975 38.9028C50.1772 38.9028 49.4072 39.5789 49.257 40.4991C48.4869 44.9126 44.6369 48.2932 39.998 48.2932C39.6238 48.2932 39.2547 48.2712 38.8919 48.2284L35.7777 51.3426Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusedMicrophoneOff);
export default __webpack_public_path__ + "static/media/focused_microphone_off.91b93170f2da17e283cd4b9534479b41.svg";
export { ForwardRef as ReactComponent };